
export const testExecutionColumn: any = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      borderRadius: "6px 0 0",
      padding: "4px 8px",
      width: "4%",
    },
    cellStyles: {
      width: "auto",
    },
    _config: {
      type: "checkbox",
      displayInColumn: true,
      value: "id",
      isClickable: "true",
    },
    hideForChildren: true,
  },
  {
    display_name: "Execution Cycle",
    key: "name",
    showExpandWithText: true,
    headerStyles: {
      color: "#ffffff",
      background: "#7593F2",
      width: "25%"
    },
    _config:{
      type:"copy_id",
      key: "id",
      value:"content_copy",
      tooltip:"Copy the Execution Id.",
      tooltipIcon:"help",
      isClickable:true
    }
  },
  {
    display_name: "Start Time",
    key: "startTime",
    headerStyles: {
      color: "#ffffff",

      background: "#7593F2",
      width: "10%",
    },
  },
  {
    display_name: "End Time",
    key: "endTime",
    headerStyles: {
      color: "#ffffff",

      background: "#7593F2",
      width: "10%",
    },
  },
  {
    display_name: "Release",
    key: "release.name",
    headerStyles: {
      color: "#ffffff",
      background: "#7593F2",

      width: "10%"
    },
  },
  {
    display_name: "Status",
    key: "status",
    headerStyles: {
      color: "#ffffff",
      background: "#7593F2",
      width: "12%"
    },
    _config: {
      type: "lozenge_status",
      classNames: "btn-accello-secondary open-btn",
      classMapping: {
        WAITING: "waiting-class status-card",
        ABORTED: "aborted-class status-card",
        EXITED: "aborted-class status-card",
        PENDING: "aborted-class status-card",
        EXECUTING: "executing-class status-card",
        PASS: "passed-class status-card",
        FAIL: "failed-class status-card",
        SKIPPED: "aborted-class status-card"
      },
    },
  },
  {
    display_name: "Total",
    key: "totalCount",
    headerStyles: {
      color: "#ffffff",
      background: "#7593F2",
      width: "8%",
    },
    _config:{
      type:"custom_tooltip",
      mappingData: [{
        display_name: "Completed",
        key: "completedCount",
        headerStyles: {
          color: "#ffffff",
          background: "#7593F2",
          width: "85px",
        },
      },
      {
        display_name: "Executing",
        key: "executingCount",
        headerStyles: {
    
          color: "#ffffff",
          background: "#7593F2",
          width: "80px",
        },
      },
      {
        display_name: "Pending",
        key: "waitingCount",
        headerStyles: {
    
          color: "#ffffff",
          background: "#7593F2",
          width: "80px",
        },
      },],
      isClickable:true
    }
  },
  
  {
    display_name: "E-Engine",
    key: "agentType",
    headerStyles: {

      color: "#ffffff",
      background: "#7593F2",
      width: "8%",
    },
    _config: {
      type: "lozenge",
      classNames: "btn-accello-secondary open-btn",
      classMapping: {
        LOCAL: "cluster-class",
        CLUSTER: "cluster-class",
      },
    },
  },
  {
    display_name: "Self-Healed",
    key: "selfHealed",
    headerStyles: {

      color: "#ffffff",
      background: "#7593F2",
      width: "12%"
    },
    _config: {
      type: "link",
      displayInColumn: false,
    },
  },
  {
    key: "",
    display_name: "",
    hideByLevel: [0],
    cellStyles: {
      "font-size": "13px",
      color: "#FFFFFF"
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "4%",
      color: "#ffffff",
    },
    _config: {
      type: "icon",
      actionType: 'open_report',
      headerIcon: {
        type: "material",
        value: "open_in_new",
        tooltip: "Open report",
      },
      displayInColumn: false,
      isCondional: true,
      targetKey: "isDownloadable",
      value: {
        true: {
          value: "open_in_new",
          iconStyles: {
            color: "#686ff1",
            "font-size": "20px",
            cursor: "pointer",
          },
        },
      },
    },
  },
  {
    key: "openVm",
    display_name: "",
    hideByLevel: [0, 1],
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "4%",
      color: "#ffffff",
    },
    _config: {
      type: "asset_icon",
      actionType: "open_vm",
      iconSrc: "assets/images/virtusa-icons/local-agent.svg",
      tooltip: "Open virtual machine",
      headerIcon: {
        type: "asset",
        iconSrc: "assets/images/virtusa-icons/local-agent.svg",
        tooltip: "Open virtual machine",
      },
      conditions: [
        { key: "agentType", value: "CLUSTER" },
        { key: "executionState", value: "EXECUTING" },
      ],
      requireKey: "agent",
      urlKey: "agent.configurations.url",
      iconStyles: {
        width: "20px",
        height: "20px",
        color: "#686ff1",
        cursor: "pointer",
      },
    },
  },
  {
    key: "",
    display_name: "",
    hideByLevel: [0],
    cellStyles: {
      "font-size": "13px",
      color: "#FFFFFF"
    },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "4%",
      color: "#ffffff",
    },
    _config: {
      type: "icon",
      actionType: 'download',
      headerIcon: {
        type: "material",
        value: "download",
        tooltip: "Download",
      },
      displayInColumn: false,
      isCondional: true,
      targetKey: "isDownloadable",
      value: {
        true: {
          value: "download",
          iconStyles: {
            color: "#686ff1",
            "font-size": "20px",
            cursor: "pointer",
          },
        },
      },
    },
  },
  {
    key: "",
    display_name: "",
    hideByLevel: [0,1],
    cellStyles: {
      "font-size": "13px",
      color: "#FFFFFF"
    },
    headerStyles: {
      "text-align": "center",
      background: "#7593F2",
      "font-weight": "600",
      width: "4%",
      color: "#ffffff",
      borderRadius: "0 6px 0 0"
    },
    _config: {
      type: "icon",
      actionType: 'open_logs',
      headerIcon: {
        type: "material",
        value: "article",
        tooltip: "Logs",
      },
      displayInColumn: false,
      isCondional: true,
      targetKey: "isDownloadable",
      value: {
        true: {
          value: "article",
          iconStyles: {
            color: "#686ff1",
            "font-size": "20px",
            cursor: "pointer",
          },
        },
      },
    },
  }
];
